import type { OriginCoordinates } from '@pkg/types/surpriseBag';

export const MAP_DIMENSIONS = {
  LARGE: '700x270',
  SMALL: '350x270',
} as const;

export interface MapData {
  address: string;
  coordinates?: OriginCoordinates;
  title: string;
  errorText: string;
  storeName: string;
}
